module.exports = __webpack_public_path__ + "static/logo-postage-one.3e9e5e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-postage-one.png
// module id = 273
// module chunks = 35783957827783 222764574844450